import { render, staticRenderFns } from "./AccidentIncidentHistory.vue?vue&type=template&id=4d6f6102&scoped=true&"
import script from "./AccidentIncidentHistory.vue?vue&type=script&lang=js&"
export * from "./AccidentIncidentHistory.vue?vue&type=script&lang=js&"
import style0 from "./AccidentIncidentHistory.vue?vue&type=style&index=0&id=4d6f6102&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d6f6102",
  null
  
)

export default component.exports